import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        employeeContainer: {
            padding: remCalc(24),
            border: 'small',
            borderStyle: 'solid',
            borderColor: 'border.light',
            borderRadius: 'medium.base',
        },
        employeeTitle: {
            textStyle: 'head-medium',
            fontWeight: 'medium',
        },
        employeeCta: {
            maxW: {base: '100%', lg: remCalc(332)},
        },
    },
}
